import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, makeStyles } from '@knockrentals/knock-shared-web';
import { ManageCompanySourceView } from './ManageCompanySourceView';
import { useManageCompanySource } from './use-manage-company-source';
import { COMPANY_SOURCE_TEXT_BUTTON, COMPANY_SOURCE_MODE } from '../constants';

const useStyles = makeStyles({
  dialogContainer: {
    maxWidth: '550px',
    position: 'relative',
  },
  removeButton: {
    marginLeft: '20px',
  },
});

export const ManageCompanySourceModal = ({ companySources = [], onSubmit }) => {
  const classes = useStyles();
  const {
    errorMessage,
    getOptionsDisabled,
    handleModalMode,
    handleSubmit,
    modalMode,
    setErrorMessage,
    sources,
  } = useManageCompanySource({
    companyMarketingSources: companySources,
    reloadCompanySources: onSubmit,
  });

  const buttonVariant =
    modalMode === COMPANY_SOURCE_MODE.ADD ? 'primary' : 'outlined';

  return (
    <React.Fragment>
      <Button
        className={classes.removeButton}
        onClick={handleModalMode(COMPANY_SOURCE_MODE.REMOVE)}
        variant={buttonVariant}
      >
        {COMPANY_SOURCE_TEXT_BUTTON[COMPANY_SOURCE_MODE.REMOVE]}
      </Button>

      <Dialog
        classes={{ paperFullWidth: classes.dialogContainer }}
        disableEscapeKeyDown
        fullWidth
        onClose={handleModalMode(null)}
        open={Boolean(modalMode)}
        scroll="paper"
      >
        <ManageCompanySourceView
          buttonText={COMPANY_SOURCE_TEXT_BUTTON[modalMode]}
          errorMessage={errorMessage}
          getOptionsDisabled={getOptionsDisabled}
          onClose={handleModalMode(null)}
          onSubmit={handleSubmit}
          setErrorMessage={setErrorMessage}
          sources={sources}
        />
      </Dialog>
    </React.Fragment>
  );
};

ManageCompanySourceModal.propTypes = {
  companySources: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      companyMarketingSourceId: PropTypes.number,
      leasingTeamEnabledCount: PropTypes.number,
      id: PropTypes.number,
      isDefault: PropTypes.bool,
      isEnabled: PropTypes.bool,
      name: PropTypes.string,
    })
  ),
  onSubmit: PropTypes.func,
};
